import React from "react";
import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";

export default function PlanGateBanner({
  title = "Premium Feature",
  description = "Upgrade to a paid plan to unlock this feature, automate your workflow, and download premium PDF reports.",
  ctaLabel = "Upgrade Now",
  ctaLink = "/pricing",
  icon: CustomIcon,
}) {
  return (
    <div style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(255, 255, 255, 0.82)",
      backdropFilter: "blur(5px)",
      zIndex: 10,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "24px",
      textAlign: "center",
      borderRadius: "inherit",
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "48px",
        height: "48px",
        borderRadius: "50%",
        background: "linear-gradient(135deg, rgba(99,102,241,0.15), rgba(139,92,246,0.15))",
        marginBottom: "16px",
        color: "#8b5cf6",
      }}>
        {CustomIcon ? <CustomIcon size={22} /> : <Crown size={22} />}
      </div>
      <h3 style={{
        margin: "0 0 8px 0",
        fontSize: "1.2rem",
        fontWeight: 700,
        background: "linear-gradient(135deg, #4f46e5, #7c3aed)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}>
        {title}
      </h3>
      <p style={{
        maxWidth: "320px",
        fontSize: "0.875rem",
        color: "var(--text-muted, #64748b)",
        lineHeight: 1.5,
        margin: "0 0 20px 0",
      }}>
        {description}
      </p>
      <Link
        to={ctaLink}
        className="btn btn-primary"
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 20px",
          fontWeight: 600,
          background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
          border: "none",
          boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
        }}
      >
        <Crown size={15} />
        {ctaLabel}
      </Link>
    </div>
  );
}
